import { downloadLink } from "@/lib/utils.js";
import ResourcesModal from "@/components/resources_modal";
import { useState } from "react";

export default function DownloadLink({
  downloads,
  type,
  download,
  resource_display,
}) {
  const [show, setShow] = useState(false);
  const slicedDownloads =
    resource_display === "modal"
      ? downloads[type]?.slice(0, 5)
      : downloads[type];
  return (
    <>
      <div>
        {slicedDownloads?.map((d, i) => {
          return (
            <p key={i} className="lexcms-downloads-table-values">
              <a href={downloadLink(d)} title={d.name} target="_blank">
                {" "}
                {d.name}{" "}
              </a>
            </p>
          );
        })}
      </div>

      {downloads[type]?.length > 5 && resource_display === "modal" && (
        <div
          className="lexcms-product-download-view-all-section"
          onClick={() => setShow(true)}
        >
          <div className="lexcms-product-download-view-all">View All</div>
          <div className="lexcms-product-download-view-all-count">
            ({downloads[type]?.length})
          </div>
          <div className="lexcms-product-download-view-all-icon"></div>
        </div>
      )}
      {resource_display === "modal" && (
        <ResourcesModal show={show} setShow={setShow}>
          <h3 style={{ fontWeight: "normal" }}>
            <strong>{download.name}</strong>: {type}{" "}
          </h3>
          <hr className="lexcms-section-divider"></hr>
          <ul className="lexcms-product-download-list">
            {downloads[type]?.map((d, i) => {
              return (
                <li key={i} className="lexcms-product-download-filename">
                  <a href={downloadLink(d)} title={d.name} target="_blank">
                    {" "}
                    {d.name}{" "}
                  </a>
                </li>
              );
            })}
          </ul>
        </ResourcesModal>
      )}
    </>
  );
}
